import { render, staticRenderFns } from "./ModalAddDish.vue?vue&type=template&id=ee041410&scoped=true&lang=pug"
import script from "./ModalAddDish.vue?vue&type=script&lang=js"
export * from "./ModalAddDish.vue?vue&type=script&lang=js"
import style0 from "./ModalAddDish.vue?vue&type=style&index=0&id=ee041410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee041410",
  null
  
)

export default component.exports